import api from './api';

const B = '/api/compliance/insurance';
export const insuranceAPI = {
  list: (history) => api.get(`${B}/policies`, { params: { history } }).then((r) => r.data),
  summary: () => api.get(`${B}/summary`).then((r) => r.data),
  create: (body) => api.post(`${B}/policies`, body).then((r) => r.data),
  update: (id, body) => api.put(`${B}/policies/${id}`, body).then((r) => r.data),
  renew: (id, body) => api.post(`${B}/policies/${id}/renew`, body).then((r) => r.data),
  remove: (id) => api.delete(`${B}/policies/${id}`).then((r) => r.data),
  upload: (id, files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    return api.post(`${B}/policies/${id}/certificates`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  blob: (cid, inline) => api.get(`${B}/certificates/${cid}/download`, { params: { inline }, responseType: 'blob' }).then((r) => r.data),
};

export const INS_STATUS = {
  current: { label: 'Current', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  expiring_soon: { label: 'Expiring soon', cls: 'bg-amber-100 text-amber-900 border-amber-200' },
  expired: { label: 'Expired', cls: 'bg-rose-100 text-rose-800 border-rose-200' },
};

export const aud = (v) => (v == null || v === '' ? '—' : Number(v).toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }));
